import React from 'react';
import CPFMaskInput from '../masks/CPFMaskInput';

function UsuarioModal({ show, onClose, onSubmit, form, handleChange, emailError = '', title = 'CADASTRO DE USUÁRIO', isMaster = false }) {
  if (!show) return null;

  return (
    <div className="modal show d-block" tabIndex="-1"
      style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1055, position: 'fixed', inset: 0 }}>
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header bg-success text-white" style={{ padding: '0.35rem 1rem' }}>
            <h6 className="modal-title mb-0 small"><i className="bi bi-person me-2"></i>{title}</h6>
            <button type="button" className="btn-close btn-close-white" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <form id="usuario-form" onSubmit={onSubmit}>
              <div className="row g-3">
                <div className='col-md-4 input-group-sm'>
                  <label className='form-label'>CPF</label>
                  <CPFMaskInput
                    value={form.cpf}
                    onChange={(e) => handleChange({ target: { name: 'cpf', value: e.target.value } })}
                    id="cpf"
                    name="cpf"
                    type="text"
                  />
                </div>
                <div className='col-md-8 input-group-sm'>
                  <label className='form-label'>Nome</label>
                  <input onChange={handleChange} value={form.nome || ''} name='nome' type='text' className='form-control'></input>
                </div>
                <div className='col-md-4 input-group-sm'>
                  <label className='form-label'>Login</label>
                  <input onChange={handleChange} value={form.login || ''} name='login' type='text' className='form-control'></input>
                </div>
                <div className='col-md-4 input-group-sm'>
                  <label className='form-label'>Senha</label>
                  <input onChange={handleChange} value={form.senha || ''} name='senha' type='password' className='form-control'></input>
                </div>
                <div className='col-md-4 input-group-sm'>
                  <label className='form-label'>Situação</label>
                  <select onChange={handleChange} value={form.situacao || ''} name='situacao' className='form-select'>
                    <option value=""></option>
                    <option value="ATIVO">ATIVO</option>
                    <option value="INATIVO">INATIVO</option>
                  </select>
                </div>
                <div className='col-md-4 input-group-sm'>
                  <label className='form-label'>Tipo de Usuário</label>
                  <select onChange={handleChange} value={form.role || ''} name='role' className='form-select'>
                    <option value=""></option>
                    {isMaster && <option value="MASTER">MASTER</option>}
                    {isMaster && <option value="ADMIN">ADMINISTRADOR</option>}
                    <option value="GEST">GESTOR</option>
                    <option value="USER">USUÁRIO</option>
                  </select>
                </div>
                <div className='col-md-8 input-group-sm'>
                  <label className='form-label'>E-mail <span className="text-danger">*</span></label>
                  <input
                    onChange={handleChange}
                    value={form.email || ''}
                    name='email'
                    type='email'
                    required
                    className={`form-control ${emailError ? 'is-invalid' : ''}`}
                  />
                  {emailError && <div className="invalid-feedback">{emailError}</div>}
                </div>
                <div className='col-md-8 input-group-sm'>
                  <label className='form-label'>Cargo / Função</label>
                  <input onChange={handleChange} value={form.cargo || ''} name='cargo' type='text' className='form-control'></input>
                </div>
              </div>
            </form>
          </div>
          <div className="modal-footer" style={{ padding: '0.35rem 1rem' }}>
            <button type="button" className="btn btn-secondary btn-sm" onClick={onClose}>Cancelar</button>
            <button type="submit" form="usuario-form" className="btn btn-success btn-sm">Salvar</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UsuarioModal;
